export const CREDITS_MOVEMENT_TYPE_ADD = 'ADD';
export const CREDITS_MOVEMENT_TYPE_REMOVE = 'REMOVE';
